import { FormMode } from 'src/app/controls/common/form-mode';
import { CustomerIdentificationSettings } from 'src/app/models/customer-identification-settings';

export class CustomerIdentificationFormContext {
    /**
     * Instance du type de document affiché dans le formulaire.
     */
    public settings: CustomerIdentificationSettings;

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public formMode: FormMode = FormMode.Reading;
}
